import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { SquidexService } from '../../../../services/squidex.service';
import { Subscription } from 'rxjs'
import { isScullyGenerated, TransferStateService } from '@scullyio/ng-lib'
import { take } from 'rxjs/operators'
import { IErrorResponse } from '../../../../core.module';

@Component({
  selector: 'flowaccount-business-banner',
  templateUrl: './business-banner.component.html',
  styleUrls: ['./business-banner.component.scss'],
})
export class BusinessBannerComponent implements OnInit {
  private SubscriptionService: Subscription
  public ServiceList: any
  public BusinessList: any
  private BUSINESS_REGISTRATION_BANNER = 'BUSINESS_REGISTRATION_BANNER'
  private BUSINESS_REGISTRATION_BANNER_2 = 'BUSINESS_REGISTRATION_BANNER_2'
  private errorMessage = ''
  constructor(
    public translate: TranslateService,
    public cdref: ChangeDetectorRef,
    public readonly squidexService: SquidexService,
    protected tstate: TransferStateService,
  ) {}

  ngOnInit(): void {
    // After scully builded
    if (isScullyGenerated()) {
      this.tstate
        .useScullyTransferState(this.BUSINESS_REGISTRATION_BANNER, this.ServiceList)
        .subscribe((data: object[]) => {
          this.ServiceList = data
        })
    }
    if (isScullyGenerated()) {
      this.tstate
        .useScullyTransferState(this.BUSINESS_REGISTRATION_BANNER_2, this.BusinessList)
        .subscribe((data: object[]) => {
          this.BusinessList = data
        })
    } else {
      // run every build
      this.getTotalService()
      this.getBusinessRegistrationService()
    }
    this.cdref.markForCheck()
  }
  async getTotalService() {
    this.SubscriptionService = await this.squidexService
      .getContentSquidexApi('business-registration-pricing')
      .pipe(take(1))
      .subscribe(
        (data: object[]) => {
          this.ServiceList = data
          this.tstate.setState(this.BUSINESS_REGISTRATION_BANNER, data)
          this.cdref.markForCheck()
        },
        (e: IErrorResponse) => {
          console.error(e.errorMessage)
          this.errorMessage = e.errorMessage
        },
      )
  }
  async getBusinessRegistrationService() {
    this.SubscriptionService = await this.squidexService
      .getContentSquidexApi('business-registration-detail-list')
      .pipe(take(1))
      .subscribe(
        (data: object[]) => {
          this.BusinessList = data
          this.tstate.setState(this.BUSINESS_REGISTRATION_BANNER_2, data)
          this.cdref.markForCheck()
        },
        (e: IErrorResponse) => {
          console.error(e.errorMessage)
          this.errorMessage = e.errorMessage
        },
      )
  }
}
